import React from 'react';
import classnames from 'classnames';
import LoadingSpinner from 'v2/common/LoadingSpinner/LoadingSpinner';
import InfiniteScrollV2 from 'v2/common/InfiniteScrollV2/InfiniteScrollV2';
import { InvitedUserActions } from './components';
import styles from './InvitedUsersTab.module.scss';
import { useInfiniteUserInvites } from 'v2/queries';

export function InvitedUsersTab() {
  const {
    data: userInvitesData,
    isLoading,
    fetchNextPage,
    hasNextPage,
  } = useInfiniteUserInvites();

  const userInvites =
    userInvitesData?.pages.flatMap((page) => page.results) ?? [];

  if (isLoading) return <LoadingSpinner />;

  if (userInvites.length === 0)
    return (
      <p className={classnames('text-primary-dark mt-5 text-blue-light')}>
        You have no open invitations at this time.
      </p>
    );

  return (
    <div>
      <table className="table-gray-light" aria-label="Invited users list">
        <thead>
          <tr>
            <th>email address</th>

            <th>{/* invited user actions column */}</th>
          </tr>
        </thead>

        <tbody>
          {userInvites.map(({ id, email }) => (
            <tr key={id}>
              <td>
                <p>{email}</p>
              </td>

              <td className={styles.invitedUserActionsColumn}>
                <InvitedUserActions userInviteID={id} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <InfiniteScrollV2
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
      />
    </div>
  );
}
